import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { NotificationType } from '../../models/notification-type';

@Injectable({
  providedIn: 'root',
})
export class NotificationTypesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  notificationTypesEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/NotificationTypes`;

  getNotificationTypes(): Observable<NotificationType[]> {
    return this.utilityService.getRequest<NotificationType[]>(this.notificationTypesEndpoint);
  }
}
